import { Injectable } from '@angular/core';
import { AppSettings } from '../app.settings';
import { Router } from '@angular/router';
import { ApiClientService } from './util/api.client.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(public http: ApiClientService, public router: Router) { }

  login(user: any) {
    return this.http.post('/token/login', user);
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/pages/login']);
  }
}
